import React from 'react';
import { Box } from '@mui/material';
import ArchetypeStatsMatrix from './ArchetypeStatsMatrix';

function StatisticsPanel({ trackerFilters }) {
    return (
        <Box>
            <ArchetypeStatsMatrix trackerFilters={trackerFilters} />
        </Box>
    );
}

export default StatisticsPanel;
